import { environment } from "environments/environment";
export const APIURL =
{
    /* Project Host & Name   */
    host: environment.apiUrl,
    project_name: "API/",
    /* USER Api */
    // login: "login",
    // sign_up: "/Sign-up/",
    Menu: "MainDashboard/MenuList/",
    MPIDList: "MainDashboard/MPIDList/",
    changePass:"User/changeUserPassword",

    /** MFA */
    mfa_host: environment.mfaUrl,
    mfa_add_new_user:'auth/migrate-user',
    mfa_login: "auth/login",
    mfa_logout:"auth/logout",
    mfa_aws_verify_otp: "auth/aws-verify-otp",
    mfa_set_new_password: "auth/set-new-password",
    mfa_reset_password: "auth/reset-user-password",
    mfa_confirm_rest_password: "auth/confirm-reset-password",
    mfa_refresh_token: "auth/refresh-token",
    mfa_confirm_device:"auth/confirm-device",

    mfa_email_enable:"user/email-mfa-enable",
    mfa_email_disable:"user/email-mfa-disable",
    mfa_update_user: "user/update-user-details",
    mfa_delete_user: "user/delete-user",
    mfa_activate_user: "user/activate-user",
    mfa_deactivate_user: "user/deactivate-user",

    // mfa screen
    userList:'User/User-List',
    saveUserData:'User/Save-User-Data',
    deleteUserData:'User/Delete-User',
    getClientNameList:'User/Get-Client-Name',
    getRolesList:'User/Get-Roles',
    getUserMPIDList:'User/User-MPID-List',
    getUserDetail:'User/Get-User',


    /* QuickFilterFields API Constant Urls */
    QuickFilterFields: "Filter/QuickFilterFields/",
    Exception_QuickFilterFields : 'Exception/QuickFilterFields/',
    GetApplicationFilterQueries: "Filter/GetApplicationFilterQueries",
    StoreApplicationFilterQuery: "Filter/StoreApplicationFilterQuery/",
    DeleteApplicationFilterQuery: "Filter/DeleteApplicationFilterQuery",

    /* Main Dashboard Api Constant Urls */
    LastExecutionDate: "MainDashboard/LastExecutionfileDate/",
    MD_TransactionCount: "MainDashboard/TransactionCount/",
    MD_ExceptionCount: "MainDashboard/ExceptionCount/",
    MD_Exception_Summary_count_List: "MainDashboard/OpenExceptionList/",
    MD_Transactio_Exception_Summary: "MainDashboard/TransactionExceptionSummary/",
    MD_System_log_summary: "MainDashboard/SystemLogSummary/",
  
    /* CAT Urls */
    CAT_Dash_Last_Execution_Date: "MainDashboard/LastExecutionfileDate/",
    CAT_Dash_Report_File_Details: "CAT/CAT-Report-File-Details/",
    CAT_Dash_Pre_Validation: "MainDashboard/OpenExceptionList/",
    CAT_Dash_CAT_FINRA_Submission_Feedback: "CAT/CAT-FINRA-Submission-Feedback",
    CAT_Dash_Transaction_Counts: "MainDashboard/TransactionCount/",
    CAT_Dash_Firmwide_Summary: "MainDashboard/FirmwideCATSummary/",
    CAT_Dash_Exception_Errors: "MainDashboard/ExceptionCount/",
    CAT_Dash_Bar_Graph_PreValidation : 'CAT/CAT-Dash-Bar-Graph-PreValidation',
    CAT_Dash_Finra_Rejects: "CAT/CAT-FINRA-Rejects/",
    CAT_Dash_System_Log_Summary: "",
    CAT_ROE_Viewer: "CAT/CAT-ROE-Viewer/",
    CAT_ROE_Viewer_Count : "CAT/CAT-ROE-Viewer-Count/",
    CAT_EXPORT_CSV: "CAT/CAT-Export-CSV/",
    CAT_Exception: "CAT/CAT-Exception/",
    CLIENT_Exception: "CLIENT/Client-Exception/",  
    CAT_Exception_Get_OriginalJSON:"CAT/CAT-Exception-Get-OriginalJSON/",
    CLIENT_Exception_Get_OriginalJSON:"CLIENT/Client-Exception-Get-OriginalJSON/",
    CAT_ROE_Get_OriginalJSON: "CAT/CAT-ROE-Get-OriginalJSON",
    CAT_Exception_Summary_Update: "CAT/CAT-Exception-Summary-Update/",
    CAT_Exception_Summary_Delete: "CAT/CAT-Exception-Summary-Delete/",
    CLIENT_Exception_Summary_Update: "CLIENT/Client-Exception-Summary-Update/",
    CLIENT_Exception_Summary_Delete: "CLIENT/Client-Exception-Summary-Delete/",
    CLIENT_Exception_Mass_Correction_Update: "CLIENT/Client-Exception-Mass-Correction-Update/",
    CAT_Exception_Summary_RestoreDelete: "CAT/CAT-Exception-Summary-RestoreDelete/",
    CAT_Exception_Summary_Field_Dictionary: "CAT/CAT-Exception-Summary-Field-Dictionary/",
    CAT_FDID: "CAT/CAT-FDID/",
    CAT_FDID_Edit:"CAT/CAT-FDID-Edit",
    CAT_FDID_Delete:"CAT/CAT-FDID-Delete",
    CAT_LTID: "CAT/CAT-LTID/",
    GET_CUSTOMERS_LIST_FOR_FDID: "CAT/CAT-FDID-CustomerList/",
    GET_FDID_DETAILS: "CAT/CAT-FDID-Details/",
    GET_LTID_DETAILS: "CAT/CAT-LTID-Details/",
    CAT_Row_Details: "CAT/CAT-ROE-Details",
    CAT_Exception_Get_FDID: "CAT/CAT-Exception-Get-FDID/",
    CAT_AccountNumbers: 'CAT/FDID-AccountNumber',
    CAT_LTIDAccountNumbers: 'CAT/LTID-AccountNumber',
    CAT_AddAccount: 'CAT/addCustomerInfo',
    CAT_AddFdid: 'CAT/addFDIDInfo',
    CAT_AddLtid: 'CAT/addLTIDInfo',
    CAT_GenerateFDID: 'CAT/FDID-generate',
    CAT_ROE_Viewer_Save: 'CAT/ROE-Viewer-Save',
    CAT_Exception_MultiEdit: 'CAT/CAT-Exception-MultiEdit',
    CAT_ROE_Viewer_MultiEdit: 'CAT/CAT-ROE-MultiEdit',
    CAT_ROE_Viewer_Validation: 'CAT/ROE-Viewer-Validation',
    CAT_ROE_Move_To_FinraException: 'CAT/ROE-Viewer-Move-To-FinraException',
    CAT_ROE_Viewer_Export_Json: 'FileOperation/DownloadCatRoeJsonFile',
    CAT_ConvertEvent: 'CAT/CAT-ConvertEvent',
    CAT_ConvertEventSave: 'CAT/CAT-ConvertEventSave',
    Get_SenderIMID_DestinationType: 'CAT/Get-SenderIMID-DestinationType',
    CAT_ROE_Viewer_MultiLegDetails: 'CAT/CAT-ROE-Viewer-MultiLegDetail',
    CAT_RECON: 'CAT/CAT-Recon',
    CAT_BILLING: 'CAT/CAT-Billing',
    CAT_RECON_MISSING_DATA:'CATRecon/groupName',

    /* CAT Analytical Comments */
    CAT_Anlytics_All_COMMENT_COUNT: 'CATAnalytics/CAT-Anlytics-All-Comments-Count',
    CAT_Analytical_Comments: 'CATAnalytics/CAT-Anlytical-Comments',
    CAT_Add_Analytical_Comment: 'CATAnalytics/CAT-Add-Anlytical-Comment',
    CAT_Delete_Analytical_Comment: 'CATAnalytics/CAT-Delete-Anlytical-Comment',

    /* CAT Recon Comments */
    CAT_Recon_All_Comments: 'CAT/CAT-Recon-All-Comments',
    CAT_Add_Recon_Comment: 'CAT/CAT-Recon-Save',
    CAT_Delete_Recon_Comment: 'CAT/CAT-Recon-Delete',
    CAT_Column_Comment_Count:'CAT/CAT-Recon-Column-Count',

    /* Broker Mapping API Urls */
    CAT_BrokerMapping_List:'BrokerMapping/getDetails',
    CAT_BrokerMapping_Add:'BrokerMapping/add',
    CAT_BrokerMapping_Edit:'BrokerMapping/edit',
    CAT_BrokerMapping_Delete:'BrokerMapping/delete',
   
    /* CAIS API Urls */
    CAIS_Country_List: 'CAIS/CAIS-Country-List',
    CAIS_Summary_Field_Dictionary: "CAIS/getChoiceDetails",
    CAIS_FDID_List: 'CAIS/CAIS-FDID',
    CAIS_FDID_View: 'CAIS/FDID/View',
    CAIS_FDID_Add: 'CAIS/FDID/Add',
    CAIS_FDID_Edit: 'CAIS/FDID/Edit',
    CAIS_FDID_FINRA_Status: 'CAIS/FDID-finra-status',
    CAIS_FINRA_Edit: 'CAIS/Exception/FINRA/Edit',
    CAIS_CLIENT_Edit: 'CAIS/Exception/CLIENT/Edit',
    CAIS_Generate_TID_Hash: 'CAIS/Generate-TID-Hash',
    Natural_Person_List: 'CAIS/Natural-Person',
    addNaturalPersonData: 'CAIS/Add-Natural-Person',
    Legal_Entity_List: 'CAIS/Legal-Entity',
    addLegalEntityData: 'CAIS/Add-Legal-Entity',
    CAIS_LTID_List: 'CAIS/CAIS-LTID',
    addCAISLTIDData: 'CAIS/Add-CAIS-LTID',
    CAIS_TID_List: 'CAIS/CAIS-TID',
    updateCAISTIDData: 'CAIS/Update-CAIS-TID',
    CAIS_Exception:'CAIS/getExceptionList',
    CAIS_Exception_ReportDateList:'CAIS/getExceptionReportDateList',
    CAIS_Exception_View:'CAIS/Exception/View',
    CAIS_Exception_Edit:'CAIS/Exception/Edit',
    CAIS_Exception_Delete:'CAIS/Exception/FINRA/Delete',
    CAIS_Exception_RestoreDelete:'CAIS/Exception/FINRA/RestoreDeleted',
    CAIS_Search_Customer: 'CAIS/searchCustomerSuggestions',  
    CAIS_Customer_List: 'CAIS/getAllCustomers',
    CAIS_RECON: 'CAIS/CAIS-Recon',

    /* FINRA Feedback Exception */
    FINRA_EXCEPTION: "CAT/Finra-Exception/",
    FINRA_EXCEPTION_SUMMARY: "CAT/Finra-Exception/Finra-Exception-Summary",
    FINRA_EXCEPTION_CODE_SUMMARY_DETAIL: "CAT/Finra-Exception/Finra-Exception-Code-Summary-Detail",
    FINRA_ConvertEvent: 'CAT/Finra-ConvertEvent',
    FINRA_EXCEPTION_SAVE:"/CAT/Finra-Exception/save/",
    FINRA_Exception_MultiEdit: "FINRA-Exception-MultiEdit",
    FINRA_ConvertEventSave: 'CAT/Finra-ConvertEventSave',
    FINRA_Update_Exception_Status: 'CAT/Finra-Exception/Update-Finra-Exception-Status',
    FINRA_CREATE_PARENT: 'ROE/Create-Finra-Exception-Parent',
    Mass_Exception_Correction: 'Mass-Exception-Correction',
    
    /* Surveillance API Constant Urls */
    Market_Abuse: "Surveillance/Market-Abuse/",
    Reg_Sho: "Surveillance/Reg-Sho/",
    Exception_Viewer: 'Exception/Exception-Data/',
    Exception_User_List: 'Exception/User-List/',
    Exception_Update_Client_Data_Exception_Status: 'Exception/Update-Client-Data-Exception-Status/',
    Exception_Client_Data_Exception_Details: 'Exception/Client-Data-Exception-Details/',
    Exception_Market_Data_Graph: 'Exception/Market-Data-Graph/',
    Exception_Exception_List: 'Exception/Exception-List/',
    Exception_ExceptionCodes_List: 'Exception/Exception-Codes/',
    Market_Access: "Surveillance/Market-Access/",
    Destination_Detail_List: "Surveillance/Market-Access/DestinationDetailList",
    Customer_Detail_List: "Surveillance/Market-Access/CustomerDetailList",
    Trader_Detail_List: "Surveillance/Market-Access/TraderDetailList",
    Max_Price_Deviation: "Surveillance/Market-Access/MaxPriceDeviation",
    Max_Order_Quantity_30_Day_ADV: "Surveillance/Market-Access/MaxOrderQuantity30DayAdv",
    Max_Daily_Gross_Notional: "Surveillance/Market-Access/MaxDailyGrossNotional",
    
    /*Trade-Reporting API Constant Urls */
    Odd_Lot_Exceptions: "Trade-Reporting/Odd-Lot-Exceptions/",
    Late_Report: "Trade-Reporting/Late-Report/",
    Non_Regular_Exceptions: "Trade-Reporting/Non-Regular-Exceptions/",
    Trading_Halt_Exceptions: "Trade-Reporting/Trading-Halt-Exceptions/",
    Non_Regular_Trade_Report_Summary: "Trade-Reporting/Non-Regular-Trade-Report-Summary/",

    /* My Data Viewer API Constant Urls */
    DatesForClientData: "MyDataViewer/GetDatesForClientData/",
    Orders: "MyDataViewer/Orders/",
    Trades: "MyDataViewer/Trades/",
    Routes: "MyDataViewer/Routes/",
    OrdersCount: "MyDataViewer/Orders-Count/",
    TradesCount: "MyDataViewer/Trades-Count/",
    RoutesCount: "MyDataViewer/Routes-Count/",
    ACT_Trades: "MyDataViewer/ACT-Trades/",
    Route_Stat: 'MyDataViewer/Route-Stat/',
    Borrow_Limit: "MyDataViewer/Borrow-Limit/",
    Prop_Quotes: 'MyDataViewer/Prop-Quotes/',
    Allocation:'MyDataViewer/Allocation',
    AllocationCount:'MyDataViewer/Allocation-Count',
    Reg_MM_List:'MyDataViewer/Reg-MM-List',

    /* Ref Data Viewer Constant Urls */
    Security_Master: 'RefDataViewer/Security-Master/',
    Equities_Symbol: 'RefDataViewer/Equities-Symbol/',
    Options_Symbol: 'RefDataViewer/Options-Symbol/',
    MPID_List: 'RefDataViewer/MPID-List/',
    CAT_Error_Codes: 'RefDataViewer/CAT-Error-Codes/',
    CAIS_Error_Codes: 'RefDataViewer/CAIS-Error-Codes/',
    Dually_Listed_Stock: 'RefDataViewer/Dually-Listed-Stock/',
    OptionOriginCode: 'OptionOriginCode/GetData',
    OptionOriginCode_GetGraph: 'OptionOriginCode/GetGraph',
    OptionOriginCode_GetCMTADetails: 'OptionOriginCode/GetCMTADetails',

    /* Toolbar Constant Urls */
    FileUploadDetails: "Toolbar/FileUploadDetails/",
    FileUploadURL: "Toolbar/FileUpload/",
    FileUploadMove: "Toolbar/FileUploadMove/",
    FileUploadDelete: "Toolbar/FileUploadDelete/",
    GenerateFileGenerate: "Toolbar/GenerateFileGenerate/",
    GenerateFileValidate: "Toolbar/GenerateFileValidate/",
    CATFileDownload:"Toolbar/CATFileDownload/",
    CAISFileDownload: "Toolbar/CAISFileDownload/",
    GenerateFileStartValidation: "Toolbar/GenerateFileStartValidation/",
    GenerateFileStartValidationUI: "Toolbar/GenerateFileStartValidationUI/",
    RunScript: "Toolbar/RunScript/",
    CAT_Get_Group_List:"Toolbar/CAT-Get-Group-List",
    system_Monitor_Logs: "Toolbar/SystemMonitorLogs/",
    Move_Staging_To_Master: "Toolbar/moveStagingToMaster",
    CAT_Get_File_List : "Toolbar/Get-Cat-File-List",
    GET_CLIENT_FILE_LIST : 'Toolbar/Get-Client-File-List',
    GETCompReviewsetupDetails:'Toolbar/CompReviewSetup/',
    UpdateCompReviewsetupDetails:'Toolbar/Update-CompReviewSetup',

    Finra_Exception_Repair_File:"FileOperation/DownloadFinraExceptionJSONFile",
    MPIDServiceList: "FileOperation/MPIDServiceList",

    Order_Viewer_OrderList:"OrderViewer/GetOrderIDList",
    Order_Viewer_CAT_data:"OrderViewer/GetOrderViewerCATData",
    Order_Viewer_Order_data:"OrderViewer/GetOrderViewerOrderData",
    Order_Viewer_Trade_data:"OrderViewer/GetOrderViewerTradeData",
    Order_Viewer_Route_data:"OrderViewer/GetOrderViewerRouteData",
    Order_Viewer_tree_data:"OrderViewer/GetTreeData",
    Representative_Aggo_Orders:"OrderViewer/Representative-Aggo-Orders",
    Representative_Aggo_Order_Execution:"OrderViewer/Representative-Aggo-Order-Execution",

    userLog:'User/User-Login-Details',
    Audit_Record_Details:"Audit/Record-Details",
    Audit_CAIS_Record_Details:"Audit/CAIS/Record-Details",
    LogUserActivity:"User/Log-User-Activity",
    GetUserActivityLog: "User/Get-User-Activity-Log",

    // New ROE Entry
    New_ROE_Entry_Save: 'ROE/Save-ROE-Data',
    Get_Required_Fields_BY_Type: 'ROE/get-required-fields-by-type',
    GET_OriginalJSON_ForEdit_Screen:"ROE/get_originalJSON_forEdit_screen",

    // Reg-Inquiry Screen
    getInquiryExecutionPrivilege: 'RegInquiry/Get-Inquiry-Execution-Privilege',
    InquiryQueryFileUploadURL:'RegInquiry/FileUpload',
    saveInquiry:'RegInquiry/Save-Inquiry',
    getInquiryList:'RegInquiry/Get-Inquiry-List',
    getInquiryDetails:'RegInquiry/Get-Inquiry-Details',
    deleteInquiries: 'RegInquiry/Delete-Inquiries',
    getInquiryComments: 'RegInquiry/Get-Inquiry-Comments',
    addInquiryComment: 'RegInquiry/Add-Inquiry-Comment',
    deleteInquiryComments: 'RegInquiry/Delete-Inquiry-Comments',
    getQueryComments: 'RegInquiry/Get-Query-Comments',
    addQueryComment: 'RegInquiry/Add-Query-Comment',
    deleteQueryComments: 'RegInquiry/Delete-Query-Comments',
    fetchInquiryResult: 'RegInquiry/Fetch-Inquiry-Result',
    getInquiryResults: 'RegInquiry/Get-Inquiry-Results',
    updateInquiryQuery: 'RegInquiry/Update-Inquiry-Query',


    //Comparative-Review Screen
    Comparative_Review_Sample:"CAT/Comparative-Review/Sample-Viewer",
    Comparative_Review_Sample_Add:"CAT/Comparative-Review/Sample-Viewer/Add",
    Comparative_Review_Sample_Edit:"CAT/Comparative-Review/Sample-Viewer/Edit",
    Comparative_Review_Sample_Delete:"CAT/Comparative-Review/Sample-Viewer/Delete",
    Comparative_Review_Sample_Generate:"CAT/Comparative-Review/Sample-Viewer/Generation",
    Comparative_Review_Report_GroupNames:"CAT/Comparative-Review/Report-Viewer/quickFilterList",
    Comparative_Review_Report:"CAT/Comparative-Review/Report-Viewer",
    Comparative_Review_Report_Export:"CAT/Comparative-Review/Report-Viewer-Export",
    Comparative_Review_Report_Generate:"CAT/Comparative-Review/Report-Viewer/Generation",
    Comparative_Review_Report_Delete:"CAT/Comparative-Review/Report-Viewer/Delete",
    Comparative_Review_View_Details:'CAT/Comparative-Review/Report-Viewer/CompareViewDetails',
    Comparative_Review_Save_Schedule_Report_Details:'CAT/Comparative-Review/Report-Viewer/Save-Schedule-Report',
    Comparative_Review_Get_Schedule_Report_Details:'CAT/Comparative-Review/Report-Viewer/Get-Schedule-Report-Details',
    Comparative_Review_Exception:"CAT/Comparative-Review/Exception",
    Comparative_Review_Exception_Summary:"CAT/Comparative-Review/Exception/ErrorCodeSummary",
    Comp_Review_Add_Comment:'CAT/Comparative-Review/Add-Comment',
    Comp_Review_Get_Comments:'CAT/Comparative-Review/Get-Comments',

    /* ODR Venue Details API Urls */
    ODR_VenueDetails_List:'ODR/VenueDetails',
    ODR_VenueDetails_Add:'ODR/VenueDetails/add',
    ODR_VenueDetails_Edit:'ODR/VenueDetails/edit',
    ODR_VenueDetails_Delete:'ODR/VenueDetails/delete',
    ODR_ExchangeList:'ODR/ExchangeList',
    ODR_VenueDetails_Approve: 'ODR/VenueDetails/approve',

    /* ODR Venue Rates API Urls */
    ODR_VenueRates_List:'ODR/VenueRates',
    ODR_VenueRates_Add:'ODR/VenueRates/add',
    ODR_VenueRates_Edit:'ODR/VenueRates/edit',
    ODR_VenueRates_Delete:'ODR/VenueRates/delete',

    /* ODR Reports Urls */
    ODR_Reports_List:'ODR/Reports',
    ODR_Reports_Edit:'ODR/Reports/edit',
    ODR_Reports_Generate_Report:'ODR/Reports/Generate-Report',
    ODR_Reports_Customer_List:'ODR/Reports/Customer-List',
    ODR_Reports_Sender_IMID_LIST:'ODR/Reports/Sender-IMID',
    ODR_Reports_Download:'ODR/Reports/Generate-Report-Link',
    ODR_Reports_Delete:'ODR/Reports/delete',
    ODR_Last_Execution_Dates: "ODR/Last-Execution-Dates/",
    ODR_System_Monitor_Logs: "ODR/System-Logs/",
    ODR_Processed_Transactiions: "ODR/Transactions-Details",
    ODR_Processed_Transactiions_Summary: "ODR/Transactions-Summary",
    ODR_Processed_Transactiions_Exceptions: "ODR/Exceptions",
    ODR_In_Transactions: "ODR/In-Transactions",
    ODR_In_Transactions_Columns: "ODR/In-Transactions-Columns",
    ODR_Order_Viewer: "ODR/ODR-Order-Viewer",
    ODR_Order_comparison:"ODR/ODR-Order-Comparison",
    CAT_Order_comparison:"CATAnalytics/CAT-Order-Comparison",
    CAT_Route_comparison:"CATAnalytics/CAT-Route-Comparison"
};